import { useOnboardingFlow } from "./useOnboardingFlow";
import {
  useOnboardingSurface,
  type OnboardingStepNavigation,
} from "./useOnboardingSurface";

/**
 * The counter and Continue for whichever sequence the step is being shown in.
 *
 * The same step components run in two sequences: the main flow (docked sheet
 * or modal, ending on the city) and sign-up's (ending on "How did you hear
 * about us?"). Steps ask this rather than `useOnboardingFlow` for anything
 * about *position*, so neither sequence has to know the other exists.
 */
export function useOnboardingStepNavigation(): OnboardingStepNavigation {
  const { navigation } = useOnboardingSurface();
  const { stepNumber, totalSteps, goNext } = useOnboardingFlow();
  return navigation ?? { stepNumber, totalSteps, goNext };
}
